import React, { useCallback, useState, useEffect, Fragment } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
//import settings from './../../Settings.json';
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import moment from 'moment';
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
//import ReactQuill from 'react-quill-new';
//import QuillToolbar, { modules, formats } from "../../Helpers/QuillToolbar.js";
//import 'react-quill-new/dist/quill.snow.css';
import { decodeToken, isExpired } from "react-jwt";
import JoditEditor from 'jodit-react';
import { joditToolbar } from './../../Helpers/JoditToolbar.js';
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";

const Duyuru = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [currentId, setCurrentId] = useState(0);
    const [konu, setKonu] = useState('');
    const [icerik, setIcerik] = useState('');
    const [tarihBaslangic, setTarihBaslangic] = useState(null);
    const [tarihBitis, setTarihBitis] = useState(null);
    const [aktif, setAktif] = useState(true);

    const [data, setData] = useState([]);
    const [rolList, setRolList] = useState([]);
    const [checkAll, setCheckAll] = useState(false);

    const rolListOnUpdate = (index, checked) => {
        const rolListTemp = [...rolList];
        rolListTemp[index].checked = checked;
        setRolList(rolListTemp);
    };

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            setShow(false);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    function createDateAsUTC(date) {
        try {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        } catch (error) {
            return null;
        }
    }

    const handleAktifChange = (e) => {
        setAktif(e.target.checked);
    }

    const handleIcerikChange = (e) => {
        setIcerik(e);
    }
    
    const getAcilisData = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Duyurular - Gör");

        setYetkiGor(tempYetkiGor);
        
        if (tempYetkiGor === true) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("Ayarlar - Duyurular - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("Ayarlar - Duyurular - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("Ayarlar - Duyurular - Sil"));
    
            setRolList((await axios.get(settings.ApiUrl + 'Rol/GetRolList', { headers: AuthService.getHeaders() })).data.value);

            await getData();
        }
    }

    const getData = async () => {
        try {
            const result = await axios.get(settings.ApiUrl + 'Duyuru/GetDuyuruList', { headers: AuthService.getHeaders() });

            if (result) {
                setData(result.data.value);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Ekle = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        setCurrentId(0);
        setKonu("");
        setIcerik("");
        setTarihBaslangic(null);
        setTarihBitis(null);
        setAktif(true);

        let temp = rolList;

        temp.forEach(rol => {
            rol.checked = false;
        });

        setRolList(temp);

        handleShow();
    }

    const Degistir = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'Duyuru/GetDuyuru/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setKonu(result.data.value.konu);
                setIcerik(result.data.value.icerik);
                setTarihBaslangic(result.data.value.tarihBaslangic);
                setTarihBitis(result.data.value.tarihBitis);
                setAktif(result.data.value.aktif);

                if (rolList && rolList.length > 0 && result.data.value.roller) {
                    let temp = rolList;

                    temp.forEach(rol => {
                        const exist = result.data.value.roller.filter(item => item.id === rol.id);
                        rol.checked = exist && exist.length > 0;
                    });

                    setRolList(temp);
                }
                
                handleShow();
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Duyuru/GetDuyuru/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Duyuru/DeleteDuyuru/', [resultGet.data.value], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        if (konu === "" || icerik === "" || tarihBaslangic === null || tarihBitis === null) {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": currentId,
                    "konu": konu,
                    "icerik": icerik,
                    "tarihBaslangic": tarihBaslangic ? moment(tarihBaslangic).format('YYYY-MM-DD') : null,
                    "tarihBitis": tarihBitis ? moment(tarihBitis).format('YYYY-MM-DD') : null,
                    "aktif": aktif,
                    "roller": rolList.filter(item => item.checked === true)
                });

                const result = await axios.post(settings.ApiUrl + 'Duyuru/InsertOrUpdateDuyuru/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    handleClose();
                    getData();
                    toast.success("Kaydedildi");
                }                   
            } catch (error) {
                toast.error(error);
            }
        }
    }

    const handleCheckAll = () => {
        setCheckAll(!checkAll);

        const temp = rolList;

        temp.forEach(item => {
            item.checked = !checkAll;
        });

        setRolList(temp);
    }

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>
            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="card info-card mb-2">
                                <table className="table table-bordered table-hover table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "center" }}>Başlangıç Tarihi</th>
                                            <th style={{ textAlign: "center" }}>Bitiş Tarihi</th>
                                            <th>Konu</th>
                                            <th style={{ textAlign: "center" }}>Durumu</th>
                                            <th style={{ textAlign: "center" }}>
                                                {yetkiEkle ? <button className="btn btn-sm btn-icon text-success" onClick={() => Ekle()}><i className="bi bi-plus-circle"></i></button> : ''}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data && data.length > 0 ?
                                                data.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td align="center">{item.tarihBaslangic === null ? "" : moment(item.tarihBaslangic).format('DD.MM.YYYY')}</td>
                                                            <td align="center">{item.tarihBitis === null ? "" : moment(item.tarihBitis).format('DD.MM.YYYY')}</td>
                                                            <td>{item.konu}</td>
                                                            <td align="center">{item.aktif === true ? <span className="badge bg-success">Aktif</span> : <span className="badge bg-danger">Pasif</span>}</td>
                                                            <td align="center">
                                                                {yetkiDegistir ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : ''}
                                                                {yetkiSil ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : ''}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td align="center" colSpan="5">
                                                        Kayıt bulunamadı
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        :
                        ""
            }

            <Modal show={show} onHide={handleClose} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Duyuru Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <div className="rol">
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblKonu" style={{ width: "136px" }}>Konu<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                        <input aria-describedby="lblKonu" type="text" className="form-control form-control-sm" value={konu} onChange={(e) => setKonu(e.target.value)}></input>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblTarihBaslagic" style={{ width: "136px" }}>Başlangıç Tarihi<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                        <div aria-describedby="lblTarihBaslangic" className="form-control form-control-sm">
                                            <DatePicker aria-describedby="lblTarihBaslangic" className="form-control form-control-sm datePickerInFormControlBox" calendarStartDay={1} todayButton="Bugün" dateFormat="dd.MM.yyyy" selected={tarihBaslangic} onChange={(update) => { setTarihBaslangic(update); }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblTarihBaslagic" style={{ width: "136px" }}>Bitiş Tarihi<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                        <div aria-describedby="lblTarihBitis" className="form-control form-control-sm">
                                            <DatePicker aria-describedby="lblTarihBitis" className="form-control form-control-sm datePickerInFormControlBox" calendarStartDay={1} todayButton="Bugün" dateFormat="dd.MM.yyyy" selected={tarihBitis} onChange={(update) => { setTarihBitis(update); }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-group input-group-sm">
                                        <label htmlFor="cbAktif" className="input-group-text" id="lblAktif" style={{ width: "136px" }}>Duyuru Aktif</label>
                                        <div aria-describedby="lblAktif" className="form-control form-control-sm text-center">
                                            <input id="cbAktif" type="checkbox" className="form-check-input" checked={aktif} onChange={(e) => handleAktifChange(e)}></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="formControlBox">
                                <div className="input-group input-group-sm" style={{padding:"3px"}}>
                                    <input id="cbCheckAll" type="checkbox" checked={checkAll} onChange={handleCheckAll} className="form-check-input" style={{fontSize:"small"}}></input>
                                    <label htmlFor="cbCheckAll" className="labelForCheckBoxOrRadio" style={{fontWeight: "bold"}}>Tüm Roller</label>
                                </div>
                                <div style={{overflowY: "auto", height: "136px"}}>
                                    <table className="table table-hover table-sm table-borderless" style={{width:"auto"}}>
                                        <tbody>
                                            {
                                                rolList && rolList.length > 0 ?
                                                rolList.map((item, index) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td>
                                                                <input id={"cbRol" + item.id} type="checkbox" className="form-check-input" checked={item.checked} onChange={() => rolListOnUpdate(index, !item.checked)}></input>
                                                            </td>
                                                            <td>
                                                                <label htmlFor={"cbRol" + item.id} style={{cursor:"pointer"}}>{item.rol}</label>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={2}>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            {/* <QuillToolbar />
                            <ReactQuill theme="snow" style={{height:"400px", position:"relative", top:"-1px"}} modules={modules} formats={formats} value={icerik} onChange={(e) => handleIcerikChange(e)} /> */}

                            <JoditEditor config={joditToolbar} value={icerik} onChange={(e) => handleIcerikChange(e)}></JoditEditor>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleClose}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default Duyuru;